import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { useApp } from '../../hooks';
import DonateButton from '../DonateButton/DonateButton';
import Modal from '../Modal/Modal';
import { TickIcon } from './TickIcon';

import styles from './DonateToYourselfModal.scss';

export const DonateToYourselfModal: FunctionComponent = () => {
  const { hideModal } = useApp();
  const { t } = useTranslation('common', { useSuspense: false });

  function handleClose() {
    hideModal();
  }

  return (
    <Modal
      onCloseRequest={handleClose}
      className={styles.modal}
      displayCloseButton
    >
      <TickIcon className={styles.icon} />
      <p>{t('fundraising.donateToYourself.modal.superHeading')}</p>
      <h1 className="jg-h1">
        {t('fundraising.donateToYourself.modal.heading')}
      </h1>
      <p>{t('fundraising.donateToYourself.modal.description')}</p>
      <DonateButton
        className={styles.donateButton}
        trackingDataPageSection="DonateToYourself"
        successType="ModalSelfDonateButtonClick"
        label={t('fundraising.donateToYourself.modal.donateButton')}
      />
      <button className={styles.dismissLink} onClick={handleClose}>
        {t('fundraising.donateToYourself.modal.dismiss')}
      </button>
    </Modal>
  );
};
